module.exports = __webpack_public_path__ + "img/icon_lottery.478494d1.png";